import React, { useRef, useState, useEffect } from 'react';
import { Popup } from 'devextreme-react';
import {
    Paging,
    Pager,
    FilterRow,
    Column,
    Lookup,
    Export,
    Button as ButtonGrid,
    Editing,
    HeaderFilter,
    Scrolling
}
    from 'devextreme-react/data-grid';
import { DataGrid } from 'devextreme-react';
import { useDispatch, useSelector } from 'react-redux'
import uri from '../../utils/uri';
import { resources } from '../../data/app';
import { goalUsersDialogAction } from '../../store/goalUsers/goalUsersDialogReducer';
import { createCustomStore } from '../../utils/proxy';
import { store } from '../../services/store';
import { cellRender } from '../../utils/common';

import Bullet, {
    Font, Margin, Size, Tooltip,
} from 'devextreme-react/bullet';

import { ProgressBar } from 'devextreme-react/progress-bar';

const NuevoUsers = (props) => {

    const { isMobile } = props;

    let dataGrid = React.createRef();

    //const [ _, canConfigureCredit ] = useAuthorization( resources.configurarCredito );

    const dispatch = useDispatch();

    const { goalUsersDialog: { open, id, text } } = useSelector(store => store);

    const closeDialog = (load) => {
        dispatch(goalUsersDialogAction({ id: 0, open: false }));

        if (load && props.onSave)
            props.onSave();

    };

    const onHiding = ({ load }) => {

        closeDialog(load, 0);

    }

    const onToolbarPreparing = (e) => {
        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Crear nuevo',
                icon: 'plus',
                type: 'default',
                stylingMode: "outlined",
                onClick: () => dataGrid.instance.addRow()
            }
        });
    }


    const propPop = isMobile ? { fullScreen: true } : { width: 800, height: 550 };

    const onInitNewRow = (e) => {
        console.log('onInitNewRow', e);
        e.data.goalId = id;
    }

    const paramenters = [['goalId', id]]


    function statusFormat(ratio) {
        return `${parseFloat(ratio*100).toFixed(2)} %`;
    }

    const DiscountCell = (cellData) => {

        const ventas = cellData.value || 0;
        const goal = cellData.data.value || 0;
        let value = 0;

        if (ventas === 0 || goal === 0)
            value = 0;
        else
            value = (ventas * 100) / goal;

        return <ProgressBar
            id="progress-bar-status"
            min={0}
            max={100}
            statusFormat={ statusFormat }
            value={value}
        />

    }


    return (
        <div>
            <Popup
                title={`Metas por vendedor`}
                {...propPop}
                onHiding={onHiding}
                visible={open}
                showCloseButton={true}
                className="bg-fbfbfb"
            >
                <div>

                    <label className="label"><b>{text}</b></label>
                    <DataGrid id="gridContainer"
                        ref={(ref) => dataGrid = ref}
                        selection={{ mode: 'single' }}
                        dataSource={store({ uri: uri.goalUsers, extraParameter: paramenters })}
                        showBorders={true}
                        showRowLines={true}
                        height={450}
                        allowColumnResizing={true}
                        allowColumnReordering={true}
                        onToolbarPreparing={onToolbarPreparing}
                        onInitNewRow={onInitNewRow}
                    >

                        <Scrolling mode="infinite" />
                        <FilterRow visible={true} />
                        <HeaderFilter visible={true} />
                        <Export enabled={true} fileName={'Metas'} allowExportSelectedData={true} />
                        <Column dataField="username" caption="Vendedor">
                            <Lookup disabled={true} dataSource={createCustomStore({ url: uri.users.base + '/catalogo', active: true })()}
                                valueExpr="username"
                                displayExpr="fullName" />
                        </Column>
                        <Column dataField="value" caption="Meta" dataType="number" width={140} cellRender={cellRender()} />
                        <Column dataField="goalReached" caption="Vendido" dataType="number" width={140} cellRender={cellRender()} />
                        <Column
                            dataField="goalReached"
                            caption="Avance %"
                            dataType="number"
                            format="percent"
                            alignment="right"
                            allowGrouping={false}
                            cellRender={DiscountCell}
                            cssClass="bullet"
                        />
                        <Editing
                            mode="row"
                            allowUpdating={true}
                            allowDeleting={true}
                            useIcons={true}
                        >

                        </Editing>
                    </DataGrid>
                </div>
            </Popup>
        </div>
    );
}

export default NuevoUsers;
